import { PageContent } from 'components/layout/PageContent'
import React, { Dispatch } from 'react'

import { AtendimentoFooter } from '../AtendimentoFooter'

interface FolhaRostoViewProps {
  atendimentoId: ID
  isAtendimentoOdonto?: boolean
  clearCache: Dispatch<void>
}

export function FolhaRostoView(props: FolhaRostoViewProps) {
  return (
    <>
      <PageContent fluid type='filled'>
        Folha de Rosto
      </PageContent>
      <AtendimentoFooter
        atendimentoId={props.atendimentoId}
        isAtendimentoOdonto={props.isAtendimentoOdonto}
        clearCache={props.clearCache}
      />
    </>
  )
}
